import { List, styled } from "common/components";

export const StyledList = styled(List)(() => ({
  overflow: "auto",
}));
